import './index.scss';
import React, { useState } from 'react';
import Button from '~/components/button';
import GeniusModal from '~/components/genius_modal';
const DocumentDownloadModal = (props) => {
    const [downloadType, setDownloadType] = useState(null);
    const resetUI = () => {
        setDownloadType(null);
    };
    return (React.createElement(GeniusModal, { isModalShowing: props.isVisible, alertForm: true, onHide: () => { props.onHide(); resetUI(); }, headerContent: React.createElement("div", null, "DOWNLOAD DOCUMENTS"), bodyContent: React.createElement(React.Fragment, null,
            React.createElement("label", { className: 'modal-input-label' }, "Select export option:"),
            React.createElement("div", { className: 'doc-type-radio-buttons' },
                React.createElement("input", { type: 'radio', className: 'input radio', id: 'download-type-pdf-toggle', "data-testid": 'download-type-pdf-toggle', name: 'download-type', onChange: () => setDownloadType('pdf'), checked: downloadType === 'pdf' }),
                React.createElement("label", { className: 'input-label', htmlFor: 'download-type-pdf-toggle' }, "PDF"),
                React.createElement("br", null),
                React.createElement("input", { type: 'radio', className: 'input radio', id: 'download-type-docx-toggle', "data-testid": 'download-type-docx-toggle', name: 'download-type', onChange: () => setDownloadType('docx'), checked: downloadType === 'docx' }),
                React.createElement("label", { className: 'input-label', htmlFor: 'download-type-docx-toggle' }, ".docx"))), footerContent: React.createElement(React.Fragment, null,
            React.createElement(Button, { id: 'cancel-download-btn', className: 'modal-action-btn', secondary: true, outline: true, onClick: () => { props.onHide(); resetUI(); } }, "Cancel"),
            React.createElement(Button, { className: 'modal-action-btn', primary: true, onClick: () => {
                    if (downloadType) {
                        props.downloadCallback(downloadType);
                        props.onHide();
                        resetUI();
                    }
                }, disabled: downloadType === null }, "Download")) }));
};
export default DocumentDownloadModal;
